import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { formatCurrency, formatDateTime } from '@/common/utils/formatters'
import { MaintenanceWorkflowValidDiagnosticEntry } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceWorkflowValidDiagnosticEntries.type'
import { Building2Icon } from 'lucide-react'

export class MaintenanceWorkflowValidDiagnosticEntriesTransformer {
  static optionsTransformer() {
    return (diagnosticEntries: MaintenanceWorkflowValidDiagnosticEntry[]) => {
      return diagnosticEntries.map((diagnosticEntry) => {
        const establishmentFantasyName =
          diagnosticEntry.forwarding?.establishment?.general_information?.fantasy_name || '--'
        const establishmentCompanyLogo =
          diagnosticEntry.forwarding?.establishment?.general_information?.company_logo?.url
        const diagnosticEntryTotalValue = formatCurrency(Number(diagnosticEntry.total_value)) || '--';
        const completedAtFormatted = diagnosticEntry.completed_at
          ? formatDateTime(new Date(diagnosticEntry.completed_at))
          : null

        return {
          value: diagnosticEntry.id,
          label: (
            <div className="flex items-center gap-1">
              <ImageWithDisplayName
                placeholderIcon={Building2Icon}
                imageUrl={establishmentCompanyLogo}
                displayName={`${establishmentFantasyName} - ${diagnosticEntryTotalValue}`}
              />

              {completedAtFormatted && <span className="text-white-400 italic">({completedAtFormatted})</span>}
            </div>
          ),
          filter: `${establishmentFantasyName} - ${diagnosticEntryTotalValue} ${completedAtFormatted ? `(${completedAtFormatted})` : ''}`,
        }
      })
    }
  }
}
